import React from 'react';
import './LoadingSpinner.css';

/**
 * Reusable loading spinner component with consistent branding
 * @param {('small'|'medium'|'large')} size - Spinner size: small (20px), medium (40px), large (48px)
 * @param {string} text - Optional loading text to display below spinner
 * @param {boolean} fullScreen - If true, centers spinner in full viewport
 */
const LoadingSpinner = ({ size = 'medium', text, fullScreen = false }) => {
  const containerClass = fullScreen
    ? 'loading-spinner-container loading-spinner-container--fullscreen'
    : 'loading-spinner-container';

  return (
    <div className={containerClass}>
      <div className={`loading-spinner loading-spinner--${size}`} />
      {text && <p className="loading-spinner-text">{text}</p>}
    </div>
  );
};

export default LoadingSpinner;
